export default "__VITE_ASSET__DaKFHuz7__"